'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rentalHistoryItem = rentalHistoryItem;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function rentalHistoryItem() {
    var clazz = function RentalHistoryItem() {
        var defaults = {
            id: null,
            productName: '',
            productImagePath: '',
            statusName: '',
            sellerArticleNumber: '',
            startDate: null,
            endDate: null,
            remark: '',
            deposit: 0,
            depositRefunded: null,
            depositRefundedDate: null,
            dailyRentalPrice: 0,
            totalRent: 0
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        calculateTotalRent: function calculateTotalRent() {
            if (this.statusName !== 'Geannuleerd' && this.statusName !== 'Annulé') {
                var startDay = (0, _moment2.default)(this.startDate, 'YYYY-MM-DD');
                var endDay = void 0;
                if (this.endDate) {
                    endDay = (0, _moment2.default)(this.endDate, 'YYYY-MM-DD');
                } else {
                    endDay = (0, _moment2.default)().startOf('day');
                }
                if (startDay.isSame(endDay)) {
                    return 0;
                }
                var daysBetween = endDay.diff(startDay, 'days') + 1; // =1
                return daysBetween * this.dailyRentalPrice;
            }
            return 0;
        },
        isCancelled: function isCancelled() {
            return this.statusName === 'Geannuleerd' || this.statusName === 'Annulé';
        }
    });

    clazz.create = function (resource) {
        var item = new clazz();
        item.id = resource.id;
        item.productName = resource.productName;
        item.productImagePath = resource.productImagePath;
        item.statusName = resource.statusName;
        item.sellerArticleNumber = resource.sellerArticleNumber;
        item.startDate = resource.startDate;
        item.endDate = resource.endDate;
        item.remark = resource.remark;
        item.deposit = resource.deposit;
        item.depositRefunded = resource.depositRefunded;
        item.depositRefundedDate = resource.depositRefundedDate;
        item.dailyRentalPrice = resource.dailyRentalPrice;
        if (item.startDate && item.dailyRentalPrice) {
            item.totalRent = item.calculateTotalRent();
        }
        item.isCancelled = item.isCancelled();
        return item;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/rentalHistoryItemModel.js
// module id = 781
// module chunks = 0